<template>

  <div :class=" backgroundClass " id="app-main-body">

    <TopNav v-if=" isAuth "/>
    <BackDrop v-if=" isAuth "/>
    <Modal v-if=" isAuth "/>
    <NetworkTab />

    <div :class=" bodyClasses " @click=" closeOverflow() ">

      <transition name="slide" mode="out-in">

        <router-view></router-view>
      </transition>
    </div>

    <TabBar v-if=" isAuth "/>
    <OverflowMenu v-if=" isAuth "/>
    <FooterBar v-if=" isAuth "/>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex';

  import TabBar from './components/order/TabBar';
  import TopNav from './components/navigation/TopNav';
  import SideNav from './components/navigation/SideNav';
  import BackDrop from './components/elements/BackDrop';
  import Modal from './components/elements/Modal';
  import NetworkTab from './components/elements/NetworkTab';
  import OptionsTab from './components/elements/OptionsTab';
  import InstallBar from './components/misc/InstallBar';
  import FooterBar from './components/navigation/FooterBar';
  import OverflowMenu from './components/navigation/OverflowMenu';
  import UiSuccess from './components/misc/UiSuccess';

  export default {

      name: 'expressOrdersApp',
      computed: {

        ...mapGetters({

            navOpen        : 'nav/topHeaderOpen',
            overflowOpen   : 'nav/overflowOpen',
            isAuth         : 'auth/isAuth',
            tabOpen        : 'orderTab/tabOpen',
            currentRoute   : 'currentRoute',
            uiSuccess      : 'uiSuccess'
        }),
        bodyClasses: function(){

          const base = [ 'app-wrap' ];
          base.push( ( this.navOpen ) ? 'app-header-open' : 'app-header-close' );
          base.push( ( this.tabOpen ) ? 'order-tab-open' : 'order-tab-close' );

          return this.isAuth ? base.join( ' ' ) : 'app-wrap';
        },
        backgroundClass: function(){
  
          const base = [];
          base.push( ( this.isAuth ) ? '' : 'app-background' );

          return base.join( ' ' );
        }
      },
      methods: {

        closeOverflow(){

          if( this.overflowOpen ) this.$store.dispatch( 'nav/closeOverflow' );
        }
      },
      components: {

        TopNav,
        SideNav,
        BackDrop,
        Modal,
        NetworkTab,
        OptionsTab,
        TabBar,
        InstallBar,
        FooterBar,
        OverflowMenu,
        UiSuccess
      }
  }
</script>

<style>

  /* GLOBAL CSS */
  @import './styles/buttons.css';
  @import './styles/forms.css';
  @import './styles/generalUi.css';
  @import './styles/telInput.css';

  .slide-enter-active {

    animation: slide-in .25s ease;
  }

  .slide-leave-active {

    animation: slide-out .25s ease;
  }

  @keyframes slide-in {

    from {

      transform: translateX( -100% );
    }
    to {

      transform: translateX( 0% );
    }
  }

  @keyframes slide-out {

    from {

      transform: translateX( 0px );
    }
    to {

      transform: translateX( 100% );
    }
  }

  * {

    -webkit-tap-highlight-color: transparent;
    box-sizing: border-box;
  }

  ::-webkit-scrollbar {

    display: none;
  }

  p {

    margin: 0;
  }

  html, body {

    display: flex;
    flex-direction: column;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background-color: #f5f5f5;
    height: 100%;
    width: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    padding: 0;
  }

  #app-main-body {

    display: flex;
    min-height: 100%;
    height: 100%;
  }

  .app-wrap {

    transition: padding-top 0.4s ease-in, padding-bottom 0.4s ease-in;
    width: 100%;
    position: relative;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    height: 100%;
    margin: 0;
  }
  .app-header-open {

    padding-top: 235px;
  }
  .app-header-close{

    padding-top: 60px;
  }
  .order-tab-open {

    padding-bottom: 120px;
  }
  .order-tab-close{

    padding-bottom: 65px;
  }

  .app-wrap > div:first-child {

    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    height: 100%;
    padding-top: 15px;
  }

</style>